import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DisplayOptionsMode } from 'src/app/constants/display-mode';
import { Option } from 'src/app/constants/option';
import { ProfileType } from 'src/app/constants/profile-type';
import { DialogData } from 'src/app/models/dialog-data';
import { GeneralOption } from 'src/app/models/general-option.t';
import { LampiranRiwayat } from 'src/app/models/lampiran-riwayat.t';
import { ApplicationService } from 'src/app/services/application.service';
import { DownloadService } from 'src/app/services/download/download.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { TokenStorageService } from 'src/app/services/token-storage/token-storage.service';
import { DateUtils } from 'src/app/utils/date-utils';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { PreviewComponent } from '../../preview/preview.component';
import { RiwayatProfileData } from '../form-riwayat-profile-data.t';

@Component({
  selector: 'app-form-riwayat-profile',
  templateUrl: './form-riwayat-profile.component.html',
  styleUrls: ['./form-riwayat-profile.component.css']
})
export class FormRiwayatProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  isNew = !this.data;
  isLoading = false;
  isUploading = false;
  title: string | undefined = '';

  noteForm = new FormControl('');

  // GOLONGAN
  golonganForm = new FormControl(Option.default.id, [Validators.required]);
  jenisForm = new FormControl('');
  tanggalTmtForm = new FormControl();
  skForm = new FormControl('');
  tanggalSkForm = new FormControl();
  pertekForm = new FormControl('');
  tanggalPertekForm = new FormControl();

  // PENDIDIKAN
  tingkatForm = new FormControl(Option.default.id, [Validators.required]);
  nameForm = new FormControl('');
  instansiForm = new FormControl('');
  noForm = new FormControl('');
  gelarDepanForm = new FormControl('');
  gelarBelakangForm = new FormControl('');
  pertamaForm = new FormControl(Option.default.id);

  // JABATAN
  jenisJabatanForm = new FormControl(Option.default.id, [Validators.required]);
  satuanKerjaForm = new FormControl('');
  unorForm = new FormControl('');
  jabFungUmumForm = new FormControl(Option.default.id, [Validators.required]);
  tanggalTmt2Form = new FormControl();

  // PNS
  statusKepegawaianForm = new FormControl(Option.default.id, [Validators.required]);
  noSttplForm = new FormControl('');
  karpegForm = new FormControl('');
  noSurat1Form = new FormControl('');
  noSurat2Form = new FormControl('');
  tanggalSttplForm = new FormControl();
  tanggalSk2Form = new FormControl();
  tanggalSuratForm = new FormControl();

  // SKP
  tahunForm = new FormControl();
  nilaiSkpForm = new FormControl();
  orientasiPelayananForm = new FormControl();
  integritasForm = new FormControl();
  komitmenForm = new FormControl();
  disiplinForm = new FormControl();
  kerjaSamaForm = new FormControl();
  kepemimpinanForm = new FormControl();
  jumlahForm = new FormControl();
  perilakuKerjaForm = new FormControl();
  prestasiKerjaForm = new FormControl();
  atasanNonPnsForm = new FormControl('');
  atasanJabatanForm = new FormControl(Option.default.id);
  penilaiJabatanForm = new FormControl(Option.default.id);
  penilaiGolonganForm = new FormControl(Option.default.id);
  atasanGolonganForm = new FormControl(Option.default.id);
  penilaiUnorNamaForm = new FormControl('');
  atasanUnorNamaForm = new FormControl('');
  penilaiNamaForm = new FormControl('');
  atasanNamaForm = new FormControl('');
  penilaiNipForm = new FormControl('');
  atasanNipForm = new FormControl('');
  penilaiStatusForm = new FormControl(Option.default.id);
  atasanStatusForm = new FormControl(Option.default.id);

  // SATYA LENCANA
  tahun2Form = new FormControl(Option.default.id);

  // KELUARGA
  hubunganForm = new FormControl(Option.default.id);

  // PENGHARGAAN
  jenisPenghargaanForm = new FormControl(Option.default.id);
  penghargaanForm = new FormControl(Option.default.id);

  uploadFileForm = new FormControl();

  onDestroy$ = new Subject<void>();
  tingkats: GeneralOption[] = [];
  golongans: GeneralOption[] = [];
  jenisKenpas: GeneralOption[] = [];
  jenisPenghargaans: GeneralOption[] = [];
  penghargaans: GeneralOption[] = [];
  hubungans: GeneralOption[] = [];
  jabatans: GeneralOption[] = [];
  jenisJabatans: GeneralOption[] = [];
  statusPegawais: GeneralOption[] = [];
  pertamas: GeneralOption[] = [Option.default, { id: 1, name: 'Ya' }, { id: 0, name: 'Tidak' }];
  tahunOption: GeneralOption[] = [Option.default, { id: 10, name: '10 tahun' }, { id: 20, name: '20 tahun' }, { id: 30, name: '30 tahun' }];

  DisplayOptionsMode = DisplayOptionsMode;
  ProfileType = ProfileType;
  fileAttr = 'Pilih File';
  fileSelected: File[] = [];

  isGolongan: boolean = false;
  isPendidikan: boolean = false;
  isJabatan: boolean = false;
  isMasaKerja: boolean = false;
  isPns: boolean = false;
  isDiklat: boolean = false;
  isKeluarga: boolean = false;
  isSkp: boolean = false;
  isPenghargaan: boolean = false;
  isOrganisasi: boolean = false;
  isCltn: boolean = false;
  isAngkaKredit: boolean = false;
  isProfesi: boolean = false;
  isPindahInstansi: boolean = false;
  isKGB: boolean = false;
  isBUP: boolean = false;
  isSatyaLencana: boolean = false;
  isKarisKarsu: boolean = false;

  constructor(
    public matDialogRef: MatDialogRef<FormRiwayatProfileComponent>,
    public downloadService: DownloadService,
    public tokenStorageService: TokenStorageService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: RiwayatProfileData,
    private snackBar: MatSnackBar,
    private profileService: ProfileService,
    private applicationService: ApplicationService,
  ) {

  }

  setScreen() {
    this.isGolongan = this.data.data.typeId === ProfileType.GOLONGAN;
    this.isPendidikan = this.data.data.typeId === ProfileType.PENDIDIKAN;
    this.isJabatan = this.data.data.typeId === ProfileType.JABATAN;
    this.isMasaKerja = this.data.data.typeId === ProfileType.PENINJAUAN_MASA_KERJA;
    this.isPns = this.data.data.typeId === ProfileType.PNS;
    this.isDiklat = this.data.data.typeId === ProfileType.DIKLAT;
    this.isKeluarga = this.data.data.typeId === ProfileType.KELUARGA;
    this.isSkp = this.data.data.typeId === ProfileType.SKP;
    this.isPenghargaan = this.data.data.typeId === ProfileType.PENGHARGAAN;
    this.isOrganisasi = this.data.data.typeId === ProfileType.ORGANISASI;
    this.isCltn = this.data.data.typeId === ProfileType.CLTN;
    this.isAngkaKredit = this.data.data.typeId === ProfileType.ANGKA_KREDIT;
    this.isProfesi = this.data.data.typeId === ProfileType.PROFESI;
    this.isPindahInstansi = this.data.data.typeId === ProfileType.PINDAH_INSTANSI;
    this.isBUP = this.data.data.typeId === ProfileType.BUP;
    this.isKGB = this.data.data.typeId === ProfileType.KGB;
    this.isSatyaLencana = this.data.data.typeId === ProfileType.SATYA_LENCANA;
    this.isKarisKarsu = this.data.data.typeId === ProfileType.KARIS_KARSU;
  }

  ngAfterViewInit(): void {
    this.setScreen();

    if (!this.isNew) {
      if (this.isGolongan) {
        this.golonganForm.setValue(this.data.data.golonganId || Option.default.id);
        this.jenisForm.setValue(this.data.data.jenisKenpaId || Option.default.id);
        this.skForm.setValue(this.data.data.noSk);
        this.tanggalSkForm.setValue(DateUtils.transform(this.data.data.tanggalSk));
        this.pertekForm.setValue(this.data.data.noPertek);
        this.tanggalPertekForm.setValue(DateUtils.transform(this.data.data.tanggalPertek));
      } else if (this.isPendidikan) {
        this.tingkatForm.setValue(this.data.data.tingkatPendidikanId || Option.default.id);
        this.nameForm.setValue(this.data.data.name);
        this.instansiForm.setValue(this.data.data.instansi);
        this.noForm.setValue(this.data.data.nomor);
        this.gelarBelakangForm.setValue(this.data.data.belakang);
        this.gelarDepanForm.setValue(this.data.data.depan);
        this.pertamaForm.setValue(this.data.data.isFirst || Option.default.id);
      } else if (this.isJabatan) {
        this.jenisJabatanForm.setValue(this.data.data.jenisJabatanId || Option.default.id);
        this.instansiForm.setValue(this.data.data.instansi);
        this.satuanKerjaForm.setValue(this.data.data.satuanKerja);
        this.unorForm.setValue(this.data.data.unor);
        this.jabFungUmumForm.setValue(this.data.data.jabatanId || Option.default.id);
        this.tanggalTmt2Form.setValue(DateUtils.transform(this.data.data.tmt2));
        this.skForm.setValue(this.data.data.noSk);
        this.tanggalSkForm.setValue(DateUtils.transform(this.data.data.tanggalSk));
      } else if (this.isPns) {
        this.statusKepegawaianForm.setValue(this.data.data.kepegawaian || Option.default.id);
        this.skForm.setValue(this.data.data.noSk);
        this.noSttplForm.setValue(this.data.data.noSttpl);
        this.karpegForm.setValue(this.data.data.karpeg);
        this.noSurat1Form.setValue(this.data.data.noSurat1);
        this.noSurat2Form.setValue(this.data.data.noSurat2);
        this.pertekForm.setValue(this.data.data.noPertek);
        this.tanggalSkForm.setValue(DateUtils.transform(this.data.data.tanggalSk));
        this.tanggalSk2Form.setValue(DateUtils.transform(this.data.data.tanggalSk2));
        this.tanggalSttplForm.setValue(DateUtils.transform(this.data.data.tanggalSttpl));
        this.tanggalTmt2Form.setValue(DateUtils.transform(this.data.data.tmt2));
        this.tanggalSuratForm.setValue(DateUtils.transform(this.data.data.tanggalSurat1));
        this.tanggalPertekForm.setValue(DateUtils.transform(this.data.data.tanggalPertek));
      } else if (this.isSkp) {
        this.tahunForm.setValue(this.data.data.tahun);
        this.nilaiSkpForm.setValue(this.data.data.nilaiSkp);
        this.orientasiPelayananForm.setValue(this.data.data.orientasiPelayanan);
        this.integritasForm.setValue(this.data.data.integritas);
        this.komitmenForm.setValue(this.data.data.komitmen);
        this.disiplinForm.setValue(this.data.data.displin);
        this.kerjaSamaForm.setValue(this.data.data.kerjaSama);
        this.kepemimpinanForm.setValue(this.data.data.kepemimpinan);
        this.nilaiSkpForm.setValue(this.data.data.nilaiSkp);
        this.jumlahForm.setValue(this.data.data.jumlah);
        this.perilakuKerjaForm.setValue(this.data.data.perilakuKerja);
        this.prestasiKerjaForm.setValue(this.data.data.prestasiKerja);
        this.atasanNonPnsForm.setValue(this.data.data.atasanNonPns);
        this.atasanJabatanForm.setValue(this.data.data.atasanJabatanId || Option.default.id);
        this.penilaiJabatanForm.setValue(this.data.data.penilaiJabatanId || Option.default.id);

        this.atasanStatusForm.setValue(this.data.data.statusAtasan || Option.default.id);
        this.penilaiStatusForm.setValue(this.data.data.statusPenilai || Option.default.id);
        this.jenisJabatanForm.setValue(this.data.data.jenisJabatanId || Option.default.id);

        this.atasanGolonganForm.setValue(this.data.data.atasanGolonganId || Option.default.id);
        this.penilaiGolonganForm.setValue(this.data.data.penilaiGolonganId || Option.default.id);
      } else if (this.isKGB) {
        this.tanggalTmt2Form.setValue(DateUtils.transform(this.data.data.tmt2));
      } else if (this.isBUP) {
        this.tanggalTmt2Form.setValue(DateUtils.transform(this.data.data.tmt2));
      } else if (this.isSatyaLencana) {
        this.tahunForm.setValue(this.data.data.tahun);
        this.tahun2Form.setValue(this.data.data.tahun2);
      } else if (this.isKeluarga) {
        this.nameForm.setValue(this.data.data.name);
        this.hubunganForm.setValue(this.data.data.hubunganId || Option.default.id);
      } else if (this.isKarisKarsu) {
        this.nameForm.setValue(this.data.data.name);
        this.noForm.setValue(this.data.data.nomor);
        this.noteForm.setValue(this.data.data.note);
      } else if (this.isPenghargaan) {
        this.tahunForm.setValue(this.data.data.tahun);
        this.jenisPenghargaanForm.setValue(this.data.data.jenisPenghargaanId || Option.default.id);
        this.penghargaanForm.setValue(this.data.data.penghargaanId || Option.default.id);
      }
      this.tanggalTmtForm.setValue(DateUtils.transform(this.data.data.tmt));
    } else {
      // setTimeout(() => {
      //   if (this.isGolongan) {
      //     this.pertekForm.setValue('');
      //     this.pertekForm.markAsTouched();
      //   } else if (this.isPendidikan) {
      //     this.pertamaForm.setValue(Option.default.id)
      //     this.pertamaForm.markAsTouched();
      //   }
      // }, 100);
    }
  }

  ngOnInit(): void {
    this.title = this.data.title;
    this.isGolongan = this.data.data.typeId === ProfileType.GOLONGAN;
    this.isPendidikan = this.data.data.typeId === ProfileType.PENDIDIKAN;

    this.isNew = !this.data || !this.data.data.id;
    this.applicationService.data$.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.tingkats = [
        ...data.tingkatPendidikans,
      ];
      this.golongans = [
        ...data.golongans,
      ];
      this.jenisJabatans = [
        ...data.jenisJabatans,
      ];
      this.jabatans = [
        ...data.jabatans,
      ];
      this.statusPegawais = [
        ...data.statusPegawais,
      ];
      this.hubungans = [
        ...data.hubungans,
      ];
      this.jenisKenpas = [
        ...data.jenisKenpas,
      ];
      this.jenisPenghargaans = [
        ...data.jenisPenghargaans,
      ];
      this.penghargaans = [
        ...data.penghargaans,
      ];
    });
  }

  preview(viewerUrl: string, url: string) {
    const dialogRef = this.dialog.open(PreviewComponent, {
      data: {
        viewerUrl: viewerUrl,
        url: url,
        isPdf: true,
      },
      maxWidth: '90vw',
      maxHeight: '90vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-width-height-dialog',
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onSubmit(): void {
    let isValid: boolean = false;
    if (this.isGolongan) {
      this.golonganForm.markAsTouched();
      isValid = this.golonganForm.valid;

      this.data.data = {
        ...this.data.data,
        golonganId: this.golonganForm.value,
        jenisKenpaId: this.jenisForm.value,
        noSk: this.skForm.value,
        tmt: this.formatDate(this.tanggalTmtForm.value),
        tanggalSk: this.formatDate(this.tanggalSkForm.value),
        noPertek: this.pertekForm.value,
        tanggalPertek: this.formatDate(this.tanggalPertekForm.value),
      }
    } else if (this.isPendidikan) {
      this.tingkatForm.markAsTouched();
      isValid = this.tingkatForm.valid;

      this.data.data = {
        ...this.data.data,
        tingkatPendidikanId: this.tingkatForm.value,
        name: this.nameForm.value,
        instansi: this.instansiForm.value,
        tmt: this.formatDate(this.tanggalTmtForm.value),
        depan: this.gelarDepanForm.value,
        belakang: this.gelarBelakangForm.value,
        isFirst: this.pertamaForm.value,
        nomor: this.noForm.value,
      }
    } else if (this.isJabatan) {
      this.jenisJabatanForm.markAsTouched();
      this.jabFungUmumForm.markAsTouched();
      isValid = this.jenisJabatanForm.valid && this.jabFungUmumForm.valid;

      this.data.data = {
        ...this.data.data,
        jenisJabatanId: this.jenisJabatanForm.value,
        instansi: this.instansiForm.value,
        satuanKerja: this.satuanKerjaForm.value,
        unor: this.unorForm.value,
        jabatanId: this.jabFungUmumForm.value,
        tmt: this.formatDate(this.tanggalTmtForm.value),
        tmt2: this.formatDate(this.tanggalTmt2Form.value),
        noSk: this.skForm.value,
        tanggalSk: this.formatDate(this.tanggalSkForm.value),
      }
    } else if (this.isPns) {
      this.statusKepegawaianForm.markAsTouched();
      this.skForm.markAsTouched();
      isValid = this.statusKepegawaianForm.valid && this.skForm.valid;

      this.data.data = {
        ...this.data.data,
        kepegawaian: this.statusKepegawaianForm.value,
        noSk: this.skForm.value,
        noSttpl: this.noSttplForm.value,
        karpeg: this.karpegForm.value,
        noSurat1: this.noSurat1Form.value,
        noSurat2: this.noSurat2Form.value,
        noPertek: this.pertekForm.value,
        tanggalSk: this.formatDate(this.tanggalSkForm.value),
        tanggalSk2: this.formatDate(this.tanggalSk2Form.value),
        tanggalSttpl: this.formatDate(this.tanggalSttplForm.value),
        tmt: this.formatDate(this.tanggalTmtForm.value),
        tmt2: this.formatDate(this.tanggalTmt2Form.value),
        tanggalSurat1: this.formatDate(this.tanggalSuratForm.value),
        tanggalPertek: this.formatDate(this.tanggalPertekForm.value),
      }
    } else if (this.isSkp) {
      this.tahunForm.markAsTouched();
      this.nilaiSkpForm.markAsTouched();
      isValid = this.tahunForm.valid && this.nilaiSkpForm.valid;

      this.data.data = {
        ...this.data.data,
        tahun: this.tahunForm.value,
        nilaiSkp: this.nilaiSkpForm.value,
        orientasiPelayanan: this.orientasiPelayananForm.value,
        integritas: this.integritasForm.value,
        komitmen: this.komitmenForm.value,
        displin: this.disiplinForm.value,
        kerjaSama: this.kerjaSamaForm.value,
        kepemimpinan: this.kepemimpinanForm.value,
        jumlah: this.jumlahForm.value,
        perilakuKerja: this.perilakuKerjaForm.value,
        prestasiKerja: this.prestasiKerjaForm.value,
        atasanNonPns: this.atasanNonPnsForm.value,
        atasanJabatanId: this.atasanJabatanForm.value,
        penilaiJabatanId: this.penilaiJabatanForm.value,
        atasanGolonganId: this.atasanGolonganForm.value,
        penilaiGolonganId: this.penilaiGolonganForm.value,
        atasanUnorNama: this.atasanUnorNamaForm.value,
        penilaiUnorNama: this.penilaiUnorNamaForm.value,
        penilaiNama: this.penilaiNamaForm.value,
        atasanNama: this.atasanNamaForm.value,
        penilaiNip: this.penilaiNipForm.value,
        atasanNip: this.atasanNipForm.value,
        statusAtasan: this.atasanStatusForm.value,
        statusPenilai: this.penilaiStatusForm.value,
        jenisJabatanId: this.jenisJabatanForm.value,
        tmt: this.formatDate(this.tanggalTmtForm.value),
        tmt2: this.formatDate(this.tanggalTmt2Form.value),
      }
    } else if (this.isKGB) {
      this.tanggalTmtForm.markAsTouched();
      this.tanggalTmt2Form.markAsTouched();
      isValid = this.tanggalTmtForm.valid && this.tanggalTmt2Form.valid;

      this.data.data = {
        ...this.data.data,
        tmt: this.formatDate(this.tanggalTmtForm.value),
        tmt2: this.formatDate(this.tanggalTmt2Form.value),
      }
    } else if (this.isBUP) {
      this.tanggalTmt2Form.markAsTouched();
      isValid = this.tanggalTmt2Form.valid;

      this.data.data = {
        ...this.data.data,
        tmt2: this.formatDate(this.tanggalTmt2Form.value),
      }
    } else if (this.isSatyaLencana) {
      this.tahunForm.markAsTouched();
      this.tahun2Form.markAsTouched();
      isValid = this.tahunForm.valid && this.tahun2Form.valid;

      this.data.data = {
        ...this.data.data,
        tahun: this.tahunForm.value,
        tahun2: this.tahun2Form.value,
      }
    } else if (this.isKeluarga) {
      this.nameForm.markAsTouched();
      this.tanggalTmtForm.markAsTouched();
      this.hubunganForm.markAsTouched();
      isValid = this.nameForm.valid && this.tanggalTmtForm.valid && this.hubunganForm.valid;

      this.data.data = {
        ...this.data.data,
        name: this.nameForm.value,
        tmt: this.formatDate(this.tanggalTmtForm.value),
        hubunganId: this.hubunganForm.value,
      }
    } else if (this.isKarisKarsu) {
      this.nameForm.markAsTouched();
      this.tanggalTmtForm.markAsTouched();
      this.noForm.markAsTouched();
      isValid = this.nameForm.valid && this.tanggalTmtForm.valid && this.noForm.valid && this.noteForm.valid;

      this.data.data = {
        ...this.data.data,
        name: this.nameForm.value,
        tmt: this.formatDate(this.tanggalTmtForm.value),
        nomor: this.noForm.value,
        note: this.noteForm.value,
      }
    } else if (this.isPenghargaan) {
      this.jenisPenghargaanForm.markAsTouched();
      this.penghargaanForm.markAsTouched();
      this.tahunForm.markAsTouched();
      isValid = this.jenisPenghargaanForm.valid && this.penghargaanForm.valid && this.tahunForm.valid;

      this.data.data = {
        ...this.data.data,
        jenisPenghargaanId: this.jenisPenghargaanForm.value,
        penghargaanId: this.penghargaanForm.value,
        tahun: this.tahunForm.value,
      }
    }

    this.data.data = {
      ...this.data.data,
      userId: this.applicationService.currentProfileId$.value,
    }

    if (!this.data.data.name) {
      this.data.data = {
        ...this.data.data,
        name: '',
      }
    }

    if (isValid) {
      this.profileService.save(this.data.data).subscribe((response) => {
        if (response?.id) {
          this.displayInfo('Perubahan data berhasil disimpan', true);
        } else {

        }
      });
    }
  }

  formatDate(value: any) {
    return value ? DateUtils.format(value) : ''
  }

  displayInfo(message: string, closeFormDialog: boolean) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Informasi',
        message: message,
        okLabel: 'OK',
        isConfirmation: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (closeFormDialog) {
        this.matDialogRef.close(true);
      }
    });
  }

  showSnackBar(message: string) {
    this.snackBar.open(message, 'OK', {
      duration: 3000,
    });
  }

  getErrorMessage(fc: FormControl) {
    if (fc.hasError('required')) {
      return 'Harus diisi';
    }

    return '';
  }

  confirmDialog(data: LampiranRiwayat) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: 'Apakah Anda yakin akan menghapus data ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isUploading = true;
        this.profileService.deleteLampiran(data).subscribe(() => {
          const index = (this.data.data.lampiran || []).indexOf(data, 0);
          if (index > -1) {
            this.data.data.lampiran!.splice(index, 1);
          }
          this.displayInfo('Dokumen berhasil dihapus', false);
          this.isUploading = false;
        });
      }
    });
  }

  selectFile(event: any): void {
    if (event.target.files.length > 0) {
      this.isUploading = true;
      this.uploadFileForm = new FormControl();
      this.profileService.upload(this.data.data.id!, event.target.files, 'profile').subscribe((data) => {
        this.isUploading = false;
        this.displayInfo('Perubahan data berhasil disimpan', false);
        if (data.dataObjects) {
          this.data.data.lampiran = [
            ...this.data.data.lampiran || [],
            ...data.dataObjects,
          ];
        }
      });
    }
  }
}
